module.exports = __webpack_public_path__ + "img/advizerai.086feedb.png";